import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { browserHistory } from 'common/utils/browserHistory';
import {
  CSSTransition,
  TransitionGroup,
} from 'react-transition-group';
// (todo micah) make sure these transition groups are right
import { AppBar } from '@unite-us/ui';
import featureFlag from 'common/utils/FeatureFlag/FeatureFlag';
import {
  REPORTS_VIEW_REPORTS,
} from 'common/utils/FeatureFlag/utils/constants';
import SearchBar from 'src/components/Search/SearchBar';
import fetchEmployees from 'src/api/core/Employees/fetchEmployees';
import updateCurrentEmployeeState from 'src/api/core/Employees/updateCurrentEmployeeState';
import { logoutUser } from 'actions/Login';
import {
  hasUserRole,
  isOrgAdmin,
  isReferralsUserAndAbove,
  isSupervisor,
  isCaseManagerAndAbove,
} from 'src/components/User/utils';
import { CREATE_REFERRAL_FORM } from 'src/components/Referrals/constants';
import { destroyForm } from 'actions/Form';
import { IntercomHelper } from '@unite-us/app-components';
import { env } from 'src/config/env';
import { redirectUserToLearn } from 'src/common/utils/utils';

import {
  hasInAppNotifications,
  hasPayerAuthorizationAccess,
  hasPayerEnrollmentsAccess,
  hasInvoicesAccess,
  hasPayerInvoicesRole,
  isMessagingEnabledFlag,
  isLearnEnabled,
  wrk105DisplayTasksV3,
} from 'common/utils/FeatureFlags/flags';
import LeftNav from './components/LeftNav';
import RightNav from './components/RightNav';
import './stylesheets/navBar.scss';

export class NavBar extends Component {
  static showHelp() {
    const newWindow = window.open('about:blank', '_blank');
    newWindow.location.href = env.UNITEUS_SUPPORT_URL;
  }

  static navigateToExports() {
    return browserHistory.push('/exports');
  }

  static navigateToUserSettings() {
    return browserHistory.push('/user/settings');
  }

  static onNewClientClick() {
    browserHistory.push('/contacts/new/search');
  }

  static onNewIntakeClicked() {
    browserHistory.push('/intakes/search');
  }

  static onNewScreeningClicked() {
    browserHistory.push('/screenings/new/search');
  }

  static onNewTaskClicked() {
    browserHistory.push('/tasksv3');
  }

  constructor(props) {
    super(props);

    this.closeSearchResults = this.closeSearchResults.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.setGroupId = this.setGroupId.bind(this);
    this.navigateTo = this.navigateTo.bind(this);
    this.linkToPath = this.linkToPath.bind(this);
    this.linkToGroupSettingsUsers = this.linkToGroupSettingsUsers.bind(this);
    this.linkToGroupSettingsPrograms = this.linkToGroupSettingsPrograms.bind(this);
    this.linkToGroupSettingsProfile = this.linkToGroupSettingsProfile.bind(this);
    this.linkToGroupReports = this.linkToGroupReports.bind(this);
    this.showReportsMenu = this.showReportsMenu.bind(this);
    this.onNewReferralClicked = this.onNewReferralClicked.bind(this);
    this.onSearchClick = this.onSearchClick.bind(this);
    this.onUserClick = this.onUserClick.bind(this);

    this.state = {
      isSearchBarOpen: false,
      loggingOut: false,
    };
  }

  componentWillUnmount() {
    if (this.state.loggingOut) {
      IntercomHelper.shutdown();
      // if user has several tabs open, and we are using autologout, update the autologout
      // storage so that we notify the other tab to logout.
      const autologoutStorageKey = 'autologout';
      if (window.localStorage && localStorage.getItem(autologoutStorageKey)) {
        const storage = localStorage.getItem('autologout');
        const storageData = JSON.parse(storage);
        const newStorageData = { ...storageData, isActive: false, logout: true };
        localStorage.setItem(autologoutStorageKey, JSON.stringify(newStorageData));
      }
    }
  }

  handleLogout() {
    IntercomHelper.shutdown();
    this.setState({ loggingOut: true }, () => {
      this.props.logoutUser();
    });
  }

  onNewReferralClicked() {
    this.props.destroyForm(CREATE_REFERRAL_FORM);
    browserHistory.push('/referrals/new/search');
  }

  onSearchClick() {
    if (this.state.isSearchBarOpen) {
      this.closeSearchResults();
    } else {
      this.setState({
        isSearchBarOpen: true,
      });
    }
  }

  async onUserClick(dispatch) {
    browserHistory.push('/user/settings');
    const { currentEmployee } = this.props;
    const { employees } = await fetchEmployees({
      userId: currentEmployee.user.id,
      providers: currentEmployee.provider.id,
    })(dispatch);
    const selectedEmployee = employees.find((employee) => employee.id === currentEmployee.id);
    const data = {
      data: selectedEmployee,
    };
    this.props.updateCurrentEmployeeState({ data });
  }

  setGroupId(id) {
    this.props.setGroupId(id);
  }

  closeSearchResults() {
    this.setState({
      isSearchBarOpen: false,
    });
  }

  navigateTo(ev, item) {
    if (item.props.route) {
      this.props.router.push(item.props.route);
    }
  }

  linkToPath(path) {
    this.props.router.push(path);
  }

  linkToGroupSettingsProfile() {
    this.props.router.push('/organization/settings');
  }

  linkToGroupSettingsUsers() {
    this.props.router.push('/organization/settings/users');
  }

  linkToGroupSettingsPrograms() {
    this.props.router.push(`/org/${this.context.groupId}/settings/programs`);
  }

  linkToGroupReports(id) {
    this.props.router.push(`/reports/group/${id}/population`);
  }

  showReportsMenu() {
    const { flagEnabled, user } = this.props;
    const { groupId } = this.context;

    // Need to optimize this to include insights
    return flagEnabled(REPORTS_VIEW_REPORTS) || isSupervisor(user, groupId);
  }

  render() {
    const {
      currentProvider,
      allUserProviders,
      currentEmployee,
      group,
      setGroupId,
      styles,
      user,
      showAuthorizations,
      showExports,
      showInsights,
      showTasks,
      showInvoices,
      showEnrollments,
      showNetworkDirectory,
      showNotifications,
      showDashboard,
      showContacts,
      canCreateContacts,
      isMessagingEnabled,
      showPayerInvoices,
      showLearnLink,
    } = this.props;

    const { groupId } = this.context;
    const networks = user.networks || [];
    const isOrgActive = currentProvider?.group?.state === 'active';
    const providerType = currentProvider?.group?.provider_type;
    const isNetworkLead = providerType === 'network_lead';
    const isPayer = providerType === 'payer';

    // user's groups with unlicensed providers filtered out
    const userGroups = user.groups?.filter(({ group: currGroup }) => {
        const matchingProvider = allUserProviders.find(({ group: providerGroup }) => currGroup.id === providerGroup.id); // eslint-disable-line max-len
        return Boolean(matchingProvider?.group.licensed);
      })
      .map(({ group: { name, id, state } }) => ({ name, id, state }));

    const navBar = this.state.isSearchBarOpen ? (
      <CSSTransition
        key="search"
        classNames="nav-search"
        timeout={{ enter: 300, exit: 300 }}
      >
        <SearchBar
          key="search"
          closeSearchResults={this.closeSearchResults}
          onSearchClick={this.onSearchClick}
        />
      </CSSTransition>
    ) : (
      <CSSTransition
        key="app-bar"
        classNames="nav-search"
        timeout={{ enter: 300, exit: 300 }}
      >
        <AppBar
          iconElementLeft={
            (
              <LeftNav
                groupId={groupId}
                isNetworkLead={isNetworkLead}
                isPayer={isPayer}
                linkToGroup={this.linkToGroupReports}
                linkToPath={this.linkToPath}
                networks={networks}
                onLeftNavLinkClick={this.linkToPath}
                onSelectExports={NavBar.navigateToExports}
                showContacts={showContacts}
                showDashboard={showDashboard}
                showExports={showExports}
                showInsights={showInsights}
                showTasks={showTasks}
                showInvoices={showInvoices}
                showEnrollments={showEnrollments}
                showAuthorizations={showAuthorizations}
                showNetworkDirectory={showNetworkDirectory}
                showPayerInvoices={showPayerInvoices}
                showReports={this.showReportsMenu()}
                isOrgActive={isOrgActive}
                currentPath={this.props.urlPath}
              />
            )
          }
          iconElementRight={
            (
              <RightNav
                isMessagingEnabled={isMessagingEnabled}
                isCaseManagerAndAbove={isCaseManagerAndAbove(user, groupId)}
                canCreateReferrals={isReferralsUserAndAbove(user, groupId)}
                canCreateScreenings={isReferralsUserAndAbove(user, groupId)}
                canCreateContacts={canCreateContacts}
                canViewContacts={showContacts}
                canViewGroupSettings={isOrgAdmin(user, groupId)}
                canViewNotifications={showNotifications || showTasks}
                currentEmployee={currentEmployee}
                onSearchClick={this.onSearchClick}
                onNewReferralClick={this.onNewReferralClicked}
                onNewClientClick={NavBar.onNewClientClick}
                onNewIntakeClick={NavBar.onNewIntakeClicked}
                onNewScreeningClick={NavBar.onNewScreeningClicked}
                onNewTaskClick={NavBar.onNewTaskClicked}
                onUserClick={this.onUserClick}
                onLearnClick={redirectUserToLearn}
                onLogoutClick={this.handleLogout}
                userAvatarUrl={user.avatar_url}
                userName={`${user.first_name} ${user.last_name}`}
                loggingOut={this.state.loggingOut}
                onOrgSettingsProgramsClick={this.linkToGroupSettingsPrograms}
                onOrgSettingsProfileClick={this.linkToGroupSettingsProfile}
                onHelpClick={NavBar.showHelp}
                group={group}
                user={user}
                groups={userGroups}
                groupId={groupId}
                setGroupId={setGroupId}
                isOrgActive={isOrgActive}
                isNetworkLead={isNetworkLead}
                showLearnLink={showLearnLink}
                showTasks={showTasks}
              />
            )
          }
          key="app-bar"
          opened={false}
          style={styles.appBar}
        />
      </CSSTransition>
    );

    return (
      <nav className="navigation" aria-labelledby="top-navigation-heading">
        <h2 className="sr-only" id="top-navigation-heading">Main navigation</h2>
        <TransitionGroup>
          {navBar}
        </TransitionGroup>
      </nav>
    );
  }
}

NavBar.propTypes = {
  allUserProviders: PropTypes.array.isRequired,
  canCreateContacts: PropTypes.bool.isRequired,
  currentEmployee: PropTypes.object.isRequired,
  currentProvider: PropTypes.object.isRequired,
  destroyForm: PropTypes.func.isRequired,
  flagEnabled: PropTypes.func.isRequired,
  group: PropTypes.shape({
    group: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
  logoutUser: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
  showAuthorizations: PropTypes.bool,
  showExports: PropTypes.bool,
  showInsights: PropTypes.bool,
  showTasks: PropTypes.bool,
  showInvoices: PropTypes.bool,
  showEnrollments: PropTypes.bool,
  showNetworkDirectory: PropTypes.bool.isRequired,
  showDashboard: PropTypes.bool.isRequired,
  showContacts: PropTypes.bool.isRequired,
  showNotifications: PropTypes.bool.isRequired,
  showPayerInvoices: PropTypes.bool,
  setGroupId: PropTypes.func.isRequired,
  styles: PropTypes.shape({
    appBar: PropTypes.object,
    appBarTitle: PropTypes.object,
    logo: PropTypes.object,
  }),
  urlPath: PropTypes.string,
  updateCurrentEmployeeState: PropTypes.func.isRequired,
  user: PropTypes.shape({
    avatar_url: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    groups: PropTypes.array,
    networks: PropTypes.array,
  }),
  isMessagingEnabled: PropTypes.bool.isRequired,
  showLearnLink: PropTypes.bool.isRequired,
};

NavBar.defaultProps = {
  group: {},
  showAuthorizations: false,
  showExports: false,
  showInsights: false,
  showInvoices: false,
  showTasks: false,
  showEnrollments: false,
  showPayerInvoices: false,
  styles: {
    appBar: {
      height: '40px',
      padding: '10px 10px 10px 20px',
      position: 'fixed',
      top: '0px',
      width: 'calc(100% - 35px)',
      boxSizing: 'content-box',
    },
    appBarTitle: {
      color: 'white',
    },
    showInsights: false,
    logo: { margin: '5px 9px 12px' },
  },
  user: {},
  urlPath: undefined,
};

function mapStateToProps(state) {
  const session = state.session;
  const { currentEmployee = {}, currentProvider = {}, providers: allUserProviders = [] } = state.globalState;
  const currentGroup = state.user.groups.find((g) => g.group.id === session.groupId) || {};

  return {
    isMessagingEnabled: isMessagingEnabledFlag(state),
    currentEmployee,
    currentProvider,
    allUserProviders,
    groupId: session.groupId,
    group: currentGroup,
    showExports: hasUserRole({
      groupId: session.groupId,
      name: 'Oversight',
      roleType: 'primary',
      user: state.user,
    }) || hasUserRole({
      groupId: session.groupId,
      name: 'Org Admin',
      roleType: 'primary',
      user: state.user,
    }),
    showInsights: hasUserRole({
      groupId: session.groupId,
      name: 'Insights',
      roleType: 'feature',
      user: state.user,
    }),
    showTasks: hasUserRole({
      groupId: session.groupId,
      name: 'Tasks',
      roleType: 'feature',
      user: state.user,
    }) && wrk105DisplayTasksV3(state),
    showNetworkDirectory: true,
    showDashboard: !hasUserRole({
      groupId: session.groupId,
      name: 'Network User',
      roleType: 'primary',
      user: state.user,
    }),
    showContacts: !hasUserRole({
      groupId: session.groupId,
      name: 'Network User',
      roleType: 'primary',
      user: state.user,
    }),
    canCreateContacts: true,
    session,
    showInvoices: hasInvoicesAccess(state),
    showAuthorizations: hasPayerAuthorizationAccess(state),
    showEnrollments: hasPayerEnrollmentsAccess(state),
    showNotifications: hasInAppNotifications(state),
    showPayerInvoices: hasPayerInvoicesRole(state),
    showLearnLink: isLearnEnabled(state),
  };
}

NavBar.contextTypes = {
  groupId: PropTypes.string.isRequired,
};

export default withRouter(connect(mapStateToProps, {
  logoutUser,
  destroyForm,
  updateCurrentEmployeeState,
})(featureFlag(NavBar)));
